var ee = require('event-emitter');

var EventEmitter = function() {
    return null;
};

ee(EventEmitter.prototype);

var emitter = new EventEmitter();

module.exports = emitter;